import React, { useState, useEffect } from 'react'
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  FormHelperText,
  Button,
  RadioGroup,
  Radio,
  Divider,
  InputAdornment,
  CircularProgress
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import { isEmpty, showToast, validateOnlyDigit } from '../../../utils/AppHelper'
import { useNavigate } from 'react-router-dom'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { styled } from '@mui/material/styles'
import TextEditor from '../../../commonComponents/TextEditor'
import AppButton from '../../../commonComponents/AppButton'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { setUserDetails } from '../../../utils/LocalStorage'
import PhoneInput from '../../../commonComponents/PhoneInput'
import { ENV } from '../../../ENV'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

export default function EditProfile ({ user }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [dropDownValues, setDorpDownValues] = useState([])

  var theme = useTheme()
  const [companyName, setCompanyName] = useState('')
  const [email, setEmail] = useState('')
  const [empFirstName, setEmpFirstName] = useState('')
  const [empLastName, setEmpLastName] = useState('')
  const [size, setSize] = useState('')
  const [websiteURL, setWebsiteURL] = useState('')
  const [contactNo, setContactNo] = useState('')
  const [contactExt, setContactExt] = useState('')
  const [industry, setIndustry] = useState('')
  const [logoImg, setLogoImg] = useState(null)
  const [companyImg, setCompanyImg] = useState(null)
  const [aboutCompany, setAboutCompany] = useState('')
  const [addressLine1, setAddressLine1] = useState('')
  const [addressLine2, setAddressLine2] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [country, setCountry] = useState('')
  const [facebookLink, setFacebookLink] = useState('')
  const [linkedInLink, setLinkedInLink] = useState('')
  const [twitterLink, setTwitterLink] = useState('')
  const [googleLink, setGoogleLink] = useState('')
  const [immigrationBenifits, setImmigrationBenifits] = useState('')
  const [ats, setATS] = useState('no')
  const [atsName, setATSName] = useState('')
  const [zipCodeLoading, setZipCodeLoading] = useState(false)
  const [formError, setFormError] = useState({})

  const companySize = [
    { id: 1, value: '1-10', size: '1-10' },
    { id: 2, value: '11-50', size: '11-50' },
    { id: 3, value: '51-200', size: '51-200' },
    { id: 4, value: '200-500', size: '200-500' },
    { id: 5, value: '501-1000', size: '501-1000' },
    { id: 6, value: '1001-5000', size: '1001-5000' },
    { id: 7, value: '5001-10000', size: '5001-10000' },
    { id: 8, value: '110000+', size: '10000+' }
  ]
  const immigrationBenifitsMenuData = [
    { id: 1, value: 'yes', label: 'Yes' },
    { id: 2, value: 'no', label: 'No' },
    {
      id: 3,
      value: 'case to case basis',
      label: 'Case to case basis (based on the job)'
    }
  ]

  useEffect(function () {
    serverData.getJobPostDropDownValues(
      {},
      result => {
        if (result.status) {
          setDorpDownValues(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
    getProfileData()
  }, [])

  function getProfileData () {
    serverData.getProfileData(
      {},
      result => {
        if (result.status) {
          let { response } = result

          setCompanyName(response.companyname)
          setEmail(response.email)
          setEmpFirstName(response.firstname)
          setEmpLastName(response.lastname)
          setSize(response.size)
          setWebsiteURL(response.websiteUrl)
          setContactNo(response.phone)
          setContactExt(response.extension)
          setIndustry(response.industry)
          setLogoImg(response.profilePicture)
          setCompanyImg(response.companyImage)
          setAboutCompany(response.aboutCompany)
          setAddressLine1(response.addressLine1)
          setAddressLine2(response.addressLine2)
          setZipCode(response.zipCode)
          setCity(response.city)
          setState(response.state)
          setCountry(response.country)
          setFacebookLink(response.facebookLink)
          setLinkedInLink(response.linkedinLink)
          setTwitterLink(response.twitterLink)
          setGoogleLink(response.googlePlusLink)
          setImmigrationBenifits(response.sponsorForeignWorkers)
          setATS(isEmpty(response.atsName) ? 'no' : 'yes')
          setATSName(response.atsName)

          const updateObjUsers = {}

          for (const key of Object.keys(user)) {
            updateObjUsers[key] = response[key] || user[key]
          }
          setUserDetails(updateObjUsers)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  function getStateAndCityByZipcode () {
    setZipCodeLoading(true)
    serverData.getStateAndCityByZipcode(
      { zipCode },
      result => {
        if (result.status) {
          let { city, state, country } = result.response
          setState(state)
          setCity(city)
          let countryObj = dropDownValues?.countries?.find(
            item => item.nicename === country
          )
          if (countryObj) {
            setCountry(countryObj.iso)
          }
        }
        setZipCodeLoading(false)
      },
      error => {
        setZipCodeLoading(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const validateForm = () => {
    const error = {}

    if (isEmpty(companyName)) {
      error.companyName = 'Please enter company name.'
    }
    if (isEmpty(email)) {
      error.email = 'Please enter email.'
    }
    if (isEmpty(empFirstName)) {
      error.empFirstName = "Please enter employer's first name."
    }
    if (isEmpty(empLastName)) {
      error.empLastName = "Please enter employer's last name."
    }
    if (isEmpty(size)) {
      error.size = 'Please select size.'
    }
    if (isEmpty(websiteURL)) {
      error.websiteURL = 'Please enter website URL.'
    }
    if (isEmpty(contactNo)) {
      error.contactNo = 'Please enter contact number'
    }

    if (isEmpty(industry) || industry === 0) {
      error.industry = 'Please select industry'
    }
    if (isEmpty(logoImg)) {
      error.logoImg = 'Please upload company logo'
    }
    if (isEmpty(aboutCompany)) {
      error.aboutCompany = 'Please enter about company'
    }
    if (isEmpty(addressLine1)) {
      error.addressLine1 = 'Please enter address line 1'
    }
    // if (isEmpty(addressLine2)) {
    //   error.addressLine2 = 'Please enter address line 2'
    // }
    if (isEmpty(zipCode)) {
      error.zipCode = 'Please enter zip code.'
    }
    if (isEmpty(city)) {
      error.city = 'Please enter city'
    }
    if (isEmpty(state)) {
      error.state = 'Please select state'
    }
    if (isEmpty(country)) {
      error.country = 'Please select country'
    }
    // if (isEmpty(linkedInLink)) {
    //   error.linkedInLink = 'Please enter linkedin link'
    // }
    // if (isEmpty(facebookLink)) {
    //   error.facebookLink = 'Please enter facebook link'
    // }
    // if (isEmpty(twitterLink)) {
    //   error.twitterLink = 'Please enter twitter link '
    // }
    // if (isEmpty(googleLink)) {
    //   error.googleLink = 'Please enter google link'
    // }
    if (isEmpty(immigrationBenifits)) {
      error.immigrationBenifits = 'Please select a value'
    }
    if (ats === 'yes' && isEmpty(atsName)) {
      error.atsName = 'Please choose ATS name'
    }

    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleUpdateProfile = () => {
    if (validateForm()) {
      setLoading(true)

      var formData = new FormData()
      formData.append('companyname', companyName)
      formData.append('firstname', empFirstName)
      formData.append('lastname', empLastName)

      formData.append('size', size)
      formData.append('websiteUrl', websiteURL)
      formData.append('phone', contactNo)
      // formData.append('extension', contactExt)
      formData.append('industry', industry)

      formData.append('profilePicture', logoImg)
      formData.append('companyImage', companyImg)
      formData.append('aboutCompany', aboutCompany)
      formData.append('addressLine1', addressLine1)
      formData.append('addressLine2', addressLine2)
      formData.append('zipCode', zipCode)
      formData.append('city', city)
      formData.append('state', state)
      formData.append('country', country)
      formData.append('facebookLink', facebookLink || '')
      formData.append('linkedinLink', linkedInLink || '')
      formData.append('twitterLink', twitterLink || '')
      formData.append('googlePlusLink', googleLink || '')
      formData.append('sponsorForeignWorkers', immigrationBenifits)
      formData.append('atsName', atsName || '')

      serverData.editEmployerProfile(
        formData,
        data => {
          if (data.status) {
            getProfileData()
            showToast(data.message, false)
            navigate('/employer/dashboard')
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  return (
    <Grid container style={{ display: 'flex' }}>
      <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
        <Grid item>
          <TextBold style={{ fontSize: '32px' }}>
            Welcome to {ENV.product_name}
          </TextBold>
        </Grid>
        <Grid item style={{ marginTop: '16px' }}>
          <TextRegular
            style={{
              fontSize: '16px',
              color: theme.palette.text.disabled
            }}
          >
            It is recommended that you complete your profile page now or you may
            complete it at the time of posting the job. To complete the profile
            page all fields with asterisks are mandatory.
          </TextRegular>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12} sm={6}
        style={{
          display: 'flex',
          alignItems: 'end',
          flexDirection: 'column'
        }}
      >
        <Grid item>
          <TextRegular style={{ color: theme.palette.text.disabled }}>
            <Button
              variant='text'
              onClick={() => navigate('/employer/dashboard')}
              style={{ textTransform: 'none', fontSize: '16px' }}
            >
              Skip profile
            </Button>
          </TextRegular>
        </Grid>
        <Grid item style={{ marginTop: '20px' }}>
          <Button
            variant='contained'
            onClick={() => {
              navigate('/employer/changepassword')
            }}
            style={{
              textTransform: 'none',
              padding: '12px 27px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 400
            }}
          >
            Change password
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6} style={{ padding: '0px', marginTop: '40px' }}>
        <Grid
          container
          style={{
            display: 'flex',
            background: theme.palette.background.paper,
            borderRadius: '16px'
          }}
        >
          <Grid item xs={12} sm={6} style={{ padding: '24px' }}>
            <TextBold style={{ fontSize: '18px' }}>
              Please complete your profile
            </TextBold>
          </Grid>
          <Grid item xs={12} sm={6}   style={{ padding: '0px' }}>
            <Divider />
          </Grid>
          <Grid container spacing={2} style={{ padding: '24px' }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.companyName}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Company name *
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={companyName}
                  error={formError.companyName}
                  helperText={formError.companyName}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setCompanyName(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.email}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Contact person email address *
                </TextRegular>
                <TextField
                  required
                  fullWidth
                  disabled={true}
                  value={email}
                  error={formError.email}
                  helperText={formError.email}
                  onChange={e => setEmail(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.empFirstName}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Contact person first name *
                </TextRegular>
                <TextField
                  required
                  fullWidth
                  value={empFirstName}
                  error={formError.empFirstName}
                  helperText={formError.empFirstName}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 30) {
                      setEmpFirstName(
                        e.target.value
                          .replace(' ', '')
                          .replace(/[^a-zA-z]/g, '')
                      )
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.empLastName}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Contact person last name *
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={empLastName}
                  error={formError.empLastName}
                  helperText={formError.empLastName}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 30) {
                      setEmpLastName(
                        e.target.value
                          .replace(' ', '')
                          .replace(/[^a-zA-z]/g, '')
                      )
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.size}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Size *
                </TextRegular>

                <Select
                  required
                  id='size'
                  value={size}
                  onChange={event => setSize(event.target.value)}
                >
                  {companySize?.map(item => (
                    <MenuItem required value={item.value}>
                      {item.size}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.size}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.websiteURL}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Website URL *
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={websiteURL}
                  error={formError.websiteURL}
                  helperText={formError.websiteURL}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 50) {
                      setWebsiteURL(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.contactNo}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Employer contact number *
                </TextRegular>

                <PhoneInput
                  id='Phone Number'
                  variant='outlined'
                  fullWidth
                  name='phone'
                  value={contactNo}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    setContactNo(input)
                  }}
                  error={formError.contactNo}
                  helperText={formError.contactNo}
                />
              </FormControl>
            </Grid>

            {/* <Grid item xs={2}>
              <FormControl fullWidth>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Extension
                </TextRegular>

                <TextField
                  fullWidth
                  value={contactExt}
                  onChange={e => {
                    var { value } = e.target
                    if (validateOnlyDigit(value) && value.length < 5) {
                      setContactExt(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.industry}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Industry *
                </TextRegular>

                <Select
                  required
                  id='industry'
                  value={industry}
                  onChange={event => setIndustry(event.target.value)}
                >
                  {dropDownValues?.industries?.map((item, index) => (
                    <MenuItem key={index} required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.industry}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} style={{ display: 'flex' }}>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextRegular
                    style={{
                      marginBottom: '6px',
                      color: theme.palette.text.secondary
                    }}
                  >
                    Company Logo *
                  </TextRegular>
                  <TextField
                    placeholder='Upload png, jpg, jpeg file'
                    value={
                      logoImg
                        ? (logoImg && logoImg.name) ||
                          'Logo.' + logoImg.split('.').pop()
                        : ''
                    }
                  />
                </FormControl>
              </Grid>
              <Grid
                item
                xs={8}
                style={{
                  marginLeft: '16px',
                  display: 'flex',
                  alignItems: 'flex-end'
                }}
              >
                <FormControl fullWidth error={formError.logoImg}>
                  <Button
                    component='label'
                    role={undefined}
                    variant='contained'
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                    style={{
                      textTransform: 'none',
                      width: 'fit-content',
                      padding: '12px 27px',
                      borderRadius: '8px'
                    }}
                  >
                    <TextBold style={{ color: theme.palette.text.opposite }}>
                      Upload Logo
                    </TextBold>
                    <VisuallyHiddenInput
                      type='file'
                      accept='.png, .jpg, .jpeg'
                      onChange={e => {
                        const error = {}
                        const file = e.target.files[0]
                        const acceptFileType = [
                          'image/png',
                          'image/jpg',
                          'image/jpeg'
                        ]
                        if (file && acceptFileType.includes(file.type)) {
                          setLogoImg(file)
                        } else {
                          error.logoImg =
                            'Please provide company logo in png, jpg or jpeg format'
                          setLogoImg(null)
                        }
                        setFormError(error)
                      }}
                    />
                  </Button>
                  <FormHelperText>{formError.logoImg}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item>
              {logoImg && (
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '8px',
                    border: `1px solid ${theme.palette.border.main}`,
                    padding: '8px',
                    marginRight: '6px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={logoImg?.name ? URL.createObjectURL(logoImg) : logoImg}
                    alt='logo'
                    style={{
                      width: '100%'
                    }}
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12} style={{ display: 'none' }}>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextRegular
                    style={{
                      marginBottom: '6px',
                      color: theme.palette.text.secondary
                    }}
                  >
                    Company Image{' '}
                    <TextRegular style={{ fontSize: 12 }}>
                      (Recommended ratio 2:1)
                    </TextRegular>
                  </TextRegular>
                  <TextField
                    placeholder='Upload png, jpg, jpeg file'
                    value={
                      companyImg
                        ? (companyImg && companyImg.name) ||
                          'Company_Image.' + companyImg?.split('.').pop()
                        : ''
                    }
                  />
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12} sm={6}
                style={{
                  marginLeft: '16px',
                  display: 'flex',
                  alignItems: 'flex-end'
                }}
              >
                <FormControl fullWidth error={formError.companyImg}>
                  <Button
                    component='label'
                    role={undefined}
                    variant='contained'
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                    style={{
                      textTransform: 'none',
                      width: 'fit-content',
                      padding: '12px 27px',
                      borderRadius: '8px'
                    }}
                  >
                    <TextBold style={{ color: theme.palette.text.opposite }}>
                      Company Image
                    </TextBold>
                    <VisuallyHiddenInput
                      type='file'
                      accept='.png, .jpg, .jpeg'
                      onChange={e => {
                        const error = {}
                        const file = e.target.files[0]
                        const acceptFileType = [
                          'image/png',
                          'image/jpg',
                          'image/jpeg'
                        ]
                        if (file && acceptFileType.includes(file.type)) {
                          setCompanyImg(file)
                        } else {
                          error.companyImg =
                            'Please provide company image in png, jpg or jpeg format'
                          setCompanyImg(null)
                        }
                        setFormError(error)
                      }}
                    />
                  </Button>
                  <FormHelperText>{formError.companyImg}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {companyImg && (
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '8px',
                    border: `1px solid ${theme.palette.border.main}`,
                    padding: '8px',
                    marginRight: '6px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={
                      companyImg?.name
                        ? URL.createObjectURL(companyImg)
                        : companyImg
                    }
                    alt='logo'
                    style={{
                      width: '100%'
                    }}
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth error={formError.aboutCompany}>
                <TextBold style={{ fontSize: '16px' }}>
                  About company *
                </TextBold>
                <TextEditor
                  getter={aboutCompany}
                  setter={setAboutCompany}
                  placeholder={
                    'Copy and past the information about you organization, work culture, corporate values, etc.'
                  }
                />
                <FormHelperText>{formError.aboutCompany}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ paddingTop: '0px', margin: '24px 0px 8px 0px' }}
            >
              <Divider style={{ width: '100%' }} />
            </Grid>

            <Grid item xs={12}>
              <TextBold style={{ fontSize: '16px' }}>Location details</TextBold>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.addressLine1}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Address Line 1 *
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={addressLine1}
                  error={formError.addressLine1}
                  helperText={formError.addressLine1}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setAddressLine1(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                // error={formError.addressLine2}
              >
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Address Line 2
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={addressLine2}
                  // error={formError.addressLine2}
                  // helperText={formError.addressLine2}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setAddressLine2(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.zipCode}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Zip code *
                </TextRegular>

                <TextField
                  required
                  fullWidth
                  value={zipCode}
                  error={formError.zipCode}
                  helperText={formError.zipCode}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    if (input.length < 12) {
                      setZipCode(input)
                    }
                  }}
                  onBlur={() => {
                    if (zipCode.length > 3) {
                      getStateAndCityByZipcode()
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        {zipCodeLoading && <CircularProgress size={24} />}
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.city}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  City *
                </TextRegular>

                <TextField
                  disabled={zipCodeLoading}
                  required
                  fullWidth
                  value={city}
                  error={formError.city}
                  helperText={formError.city}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 50) {
                      setCity(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.state}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  State *
                </TextRegular>

                <TextField
                  disabled={zipCodeLoading}
                  required
                  fullWidth
                  value={state}
                  error={formError.state}
                  helperText={formError.state}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 50) {
                      setState(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.country}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Country *
                </TextRegular>
                <Select
                  disabled={zipCodeLoading}
                  required
                  id='country'
                  value={country}
                  onChange={event => setCountry(event.target.value)}
                >
                  {dropDownValues?.countries?.map(item => (
                    <MenuItem required value={item.iso}>
                      {item.nicename}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.country}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ paddingTop: '0px', margin: '24px 0px 8px 0px' }}
            >
              <Divider style={{ width: '100%' }} />
            </Grid>

            <Grid item xs={12}>
              <TextBold style={{ fontSize: '16px' }}>
                Links to social media
              </TextBold>
            </Grid>
            <Grid item xs={12} sm={6} display={'none'}>
              <FormControl
                fullWidth
                // error={formError.facebookLink}
              >
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Facebook profile link
                </TextRegular>

                <TextField
                  fullWidth
                  value={facebookLink}
                  // error={formError.facebookLink}
                  // helperText={formError.facebookLink}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setFacebookLink(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} >
              <FormControl
                fullWidth
                // error={formError.linkedInLink}
              >
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Linkedin profile link
                </TextRegular>

                <TextField
                  fullWidth
                  value={linkedInLink}
                  // error={formError.linkedInLink}
                  // helperText={formError.linkedInLink}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setLinkedInLink(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} display={'none'}>
              <FormControl
                fullWidth
                // error={formError.twitterLink}
              >
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Twitter profile link
                </TextRegular>

                <TextField
                  fullWidth
                  value={twitterLink}
                  // error={formError.twitterLink}
                  // helperText={formError.twitterLink}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setTwitterLink(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} display={'none'}>
              <FormControl
                fullWidth
                // error={formError.googleLink}
              >
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Google+ profile link
                </TextRegular>

                <TextField
                  fullWidth
                  value={googleLink}
                  // error={formError.googleLink}
                  // helperText={formError.googleLink}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 100) {
                      setGoogleLink(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <TextBold style={{ fontSize: '16px' }}>
                Are you willing to sponsor foreign workers for immigration
                benefits for your job openings:
              </TextBold>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={formError.immigrationBenifits}>
                <TextRegular
                  style={{
                    marginBottom: '6px',
                    color: theme.palette.text.secondary
                  }}
                >
                  Select type *
                </TextRegular>
                <Select
                  id='immigrationBenifits'
                  value={immigrationBenifits}
                  onChange={event => setImmigrationBenifits(event.target.value)}
                  sx={{ width: '170px' }}
                >
                  {immigrationBenifitsMenuData?.map(item => (
                    <MenuItem required value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.immigrationBenifits}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl>
                <TextBold style={{ fontSize: '16px' }}>
                  Do you currently have an applicant tracking system (ATS)? *
                </TextBold>

                <RadioGroup
                  row
                  name='row-radio-buttons-group'
                  value={ats}
                  onChange={e => {
                    setATS(e.target.value)
                    setATSName('')
                  }}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <FormControlLabel
                    value='yes'
                    control={<Radio />}
                    label='Yes'
                  />
                  <FormControlLabel value='no' control={<Radio />} label='No' />
                </RadioGroup>
                <FormHelperText>{formError.ats}</FormHelperText>
              </FormControl>
            </Grid>
            {ats === 'yes' && (
              <Grid item xs={12}>
                <FormControl fullWidth error={formError.atsName}>
                  <InputLabel id='ats'>Select ATS name</InputLabel>
                  <Select
                    labelId='ats-label'
                    id='ats'
                    value={atsName}
                    label='Select ATS name'
                    onChange={event => setATSName(event.target.value)}
                    sx={{ width: '170px' }}
                  >
                    {[
                      { label: 'Taleo', value: 'Taleo' },
                      { label: 'Kenexa', value: 'Kenexa' },
                      { label: 'Successfactors', value: 'Successfactors' },
                      { label: 'iCims', value: 'iCims' },
                      { label: 'Peoplefluent', value: 'Peoplefluent' },
                      { label: 'Other', value: 'Other' }
                    ]?.map(item => (
                      <MenuItem required value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{formError.atsName}</FormHelperText>
                </FormControl>
              </Grid>
            )}

            <Grid item>
              <AppButton
                variant='contained'
                name={'Update profile'}
                disabled={false}
                loading={loading}
                onClick={() => handleUpdateProfile()}
                style={{
                  textTransform: 'none',
                  padding: '12px 26px',
                  borderRadius: '8px',
                  fontSize: '16px'
                }}
              />
            </Grid>
            <Grid item>
              <Button
                variant='outlined'
                onClick={() => navigate('/employer')}
                style={{
                  textTransform: 'none',
                  padding: '12px 26px',
                  borderRadius: '8px',
                  fontSize: '16px'
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
